import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Button.css';

const Button = React.forwardRef(({ className, variant = 'default', size = 'default', asChild = false, ...props }, ref) => {
  const Comp = asChild ? 'span' : 'button';
  
  const buttonClasses = classNames(
    css.button,
    css[variant],
    css[size],
    className
  );

  return (
    <Comp
      className={buttonClasses}
      ref={ref}
      {...props}
    />
  );
});

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'destructive', 'outline', 'secondary', 'ghost', 'link']),
  size: PropTypes.oneOf(['default', 'sm', 'lg', 'icon']),
  asChild: PropTypes.bool,
};

Button.displayName = 'Button';

export { Button }; 